/**
 * Footer Accordion Functionality
 * Handles the accordion toggle behavior for footer menus
 */

class FooterAccordion {
  constructor() {
    this.init();
  }

  init() {
    // Find all accordion triggers
    const triggers = document.querySelectorAll('[data-accordion-trigger]');
    
    triggers.forEach(trigger => {
      trigger.addEventListener('click', this.toggleAccordion.bind(this));
    });

    // Set initial height for accordions that are active by default
    this.setInitialStates();
  }

  setInitialStates() {
    const activeAccordions = document.querySelectorAll('.footer-sogood__menu-block--accordion.active');
    
    activeAccordions.forEach(accordion => {
      const content = accordion.querySelector('[data-accordion-content]');
      if (content) {
        content.style.maxHeight = content.scrollHeight + 'px';
      }
    });
  }

  toggleAccordion(event) {
    const trigger = event.currentTarget;
    const menuBlock = trigger.closest('.footer-sogood__menu-block--accordion');
    const content = menuBlock.querySelector('[data-accordion-content]');
    const toggle = trigger.querySelector('.footer-sogood__menu-toggle');
    
    if (menuBlock.classList.contains('active')) {
      // Close accordion
      menuBlock.classList.remove('active');
      toggle.textContent = '+';
      content.style.maxHeight = '0';
    } else {
      // Open accordion
      menuBlock.classList.add('active');
      toggle.textContent = '−';
      content.style.maxHeight = content.scrollHeight + 'px';
    }
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new FooterAccordion();
});

// Also initialize for theme editor
document.addEventListener('shopify:section:load', () => {
  new FooterAccordion();
});
